module.exports = "/assets/7a8728d83d02bfeb83e4cd88f1d6f8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/YX.png
// module id = 2046
// module chunks = 0